const SHIM_AGENT = 'shimAgent';
const SHIM_IDENTIFIERS = 'shimIdentifiers';
const SHIM_CONTACTS = 'shimContacts';
const SHIM_REGISTRIES = 'shimRegistries';
const SHIM_CREDENTIALS = 'shimCredentials';
const SHIM_NOTIFICATIONS = 'shimNotifications';

export const tags = {
  shimAgent: SHIM_AGENT,
  shimIdentifiers: SHIM_IDENTIFIERS,
  shimContacts: SHIM_CONTACTS,
  shimRegistries: SHIM_REGISTRIES,
  shimCredentials: SHIM_CREDENTIALS,
  shimNotifications: SHIM_NOTIFICATIONS,
};
